import{__assign as r}from'./../ext/tslib/tslib.es6.js';import o from"react";import{Box as t}from"../Box/Box.js";var e=function(e){return o.createElement(t,r({shrink:1,grow:1},e))};export{e as default};
//# sourceMappingURL=TableWrapper.js.map
